import BaseService from './BaseService';
import entities from 'src/config/entities';

class ThirdPartiesService extends BaseService {

  constructor() {
    super({ entity: entities.THIRD_PARTY });
  }

  async toggleStatus (id, data) {
    try {
      let result = await this.instance.put(`${id}/enable`, data)
      this._handleSuccess({translationKey: 'generic.update.success', data})
      return result
    } catch (e) {
      this._handleError({translationKey: 'generic.update.error', error: e, id: id})
    }
  }

  async getThirdPartyData (id) {
    return this.instance.get(`${id}/data`)
  }
}

export default new ThirdPartiesService();
